// extracted by mini-css-extract-plugin
module.exports = {"social_links_wrapper":"social_links_social_links_wrapper__k2gOD"};